import React, { useCallback, useState } from 'react'
import { useAdmin } from '../../contexts/AdminContext'
import { Login } from '../../types/Subscription'
import Heading from '../../components/Heading'
import Text from '../../components/Text'
import Button from '../../components/Button'
import { faArrowLeft } from '@fortawesome/free-solid-svg-icons'
import IconButton from '../../components/IconButton'
import LoginForm from '../../compositions/Subscription/Forms/LoginForm'
import { useTranslation } from 'react-i18next'
import { showToast } from '../../services/ToastService'
import { useNavigate } from 'react-router-dom'

const SubscriptionLogin: React.FC = () => {
    const { service, changeUser } = useAdmin()
    const [data, setData] = useState<Partial<Login>>({})
    const navigate = useNavigate()
    const { t } = useTranslation(['settings'])

    const changeData = useCallback((data: Partial<Login>) => {
        setData((prevElement) => ({ ...prevElement, ...data }))
    }, [])

    const submit = () => {
        service
            .login(data)
            .then((res) => {
                service.setToken('Bearer ' + res.data.access_token)
                changeUser(res.data.user)
                navigate('/subscription')
            })
            .catch(() => {
                showToast(t('subscription.loginError'), 'error')
            })
    }

    return (
        <div className={'zr-mt-3'}>
            <Heading level={3} classes={'zr-mb-4'}>
                {t('subscription.logInToYourAccount')}
            </Heading>
            <IconButton
                icon={faArrowLeft}
                color={'black'}
                onClick={() => navigate('/subscription')}
            >
                {t('subscription.back')}
            </IconButton>
            <Text classes={'zr-mt-3'}>
                {t('subscription.inCaseOfNoAccount')}
            </Text>
            <LoginForm data={data} changeData={changeData} />
            <div className={'zr-mt-4 zr-d-flex zr-justify-between'}>
                <Button
                    hierarchy={'tertiary'}
                    text={t('subscription.forgotPassword')}
                    fn={() => navigate('/subscription/password-reset')}
                />
                <Button
                    fn={() => submit()}
                    hierarchy={'primary'}
                    text={t('subscription.login')}
                />
            </div>
        </div>
    )
}

export default SubscriptionLogin
